






























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Nav, NavItem } from '../entities/nav'
import VueSlideUpDown from 'vue-slide-up-down'
import {getCDNUrl} from '@/utils/cdn'

interface Selectable {
    selected?: boolean
}

type MenuBlock
    = { type: 'link', to?: string, title: string, hasSubLinks: boolean } & NavItem & Selectable
    | { type: 'sublinks', id: string, links: Array<NavItem & Selectable> }

@Component<DashboardSubNav>({
    components: {VueSlideUpDown}
})
export default class DashboardSubNav extends Vue {

    @Prop({ type: Object, required: true }) public nav!: Nav

    public get logoImg() {
        return getCDNUrl(this.nav.logo)
    }

    public shouldMaskPrevious(idx: number): boolean {
        const prev = this.items[idx - 1]
        return prev && prev.type === 'sublinks' && prev.links && prev.links.length > 5
        && prev.id === this.$route.path.split('/')[1] && !this.$route.query.hasOwnProperty('close')
    }

    public get items() {

        const { nav, $route } = this
        const navItems = nav && nav.items || []
        const { path, query, fullPath } = $route
        const topLevel = path.split('/')[1]

        const links: MenuBlock[] = []

        navItems.forEach((item) => {

            const childId = item.items && item.items[0] && item.items[0].id
            let to = childId ? `/${item.id}/${childId}` : `/${item.id}`
            const hasSubLinks = !!childId

            if (item.title) {
                let selected = item.id === 'starter' ? path === '/overview' : path.indexOf('/' + item.id) === 0
                // if click on same link again, open/collapse
                if (hasSubLinks && item.id === path.split('/')[1]) {
                    if (query.hasOwnProperty('close')) {
                        selected = false
                        to = fullPath.replace(/close$/, '')
                    } else {
                        selected = true
                        to = fullPath + (Object.keys(query).length ? '&close' : '?close')
                    }
                }
                links.push({id: item.id, type: 'link', to, title: item.title, selected, hasSubLinks})
            }

            if (hasSubLinks) {
                links.push({
                    type: 'sublinks',
                    id: item.id,
                    links: (item.items || []).map((child) =>
                        ({...child,
                            selected: child.id === 'dashboard' ? path === '/overview' : path.indexOf(`/${item.id}/${child.id}`) === 0
                        })
                    )
                })
            }
        })

        return links
    }
}
